import { createFileRoute, Navigate } from "@tanstack/react-router";
import { LoaderIcon } from "lucide-react";

import { DiagnosticsSettingsPanel } from "../components/settings/DiagnosticsSettings";
import { useAdministrativeAccess } from "../components/settings/useAdministrativeAccess";

function SettingsDiagnosticsRoute() {
  const { canWrite, isPending } = useAdministrativeAccess();
  if (isPending) {
    return (
      <div className="flex flex-1 items-center justify-center text-muted-foreground/40">
        <LoaderIcon className="size-4 animate-spin" />
      </div>
    );
  }
  if (!canWrite) {
    return <Navigate to="/settings/general" replace />;
  }
  return <DiagnosticsSettingsPanel />;
}

export const Route = createFileRoute("/settings/diagnostics")({
  component: SettingsDiagnosticsRoute,
});
